import React, { useContext } from "react";
import { useLoadingWrapper } from "../../shared/hooks/useLoadingWrapper";
import { useChat } from "./hooks/useChat";
import { MultipleChoiceSession } from "./components/MultipleChoiceSession";
import { useSearchParams } from "react-router-dom";
import { useFetchSessionById } from "./hooks/useFetchSessionById";
import { useStableQuery } from "../../shared/hooks/useStableQuery";
import { api } from "../../convex/_generated/api";
import { Id } from "../../convex/_generated/dataModel";
import { BaseContext } from "../../shared/base-context";

export const Chat: React.FC = () => {
    const { debug } = useContext(BaseContext);
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get("sessionId") || '';

    const session = useFetchSessionById(sessionId);
    const assistant = useStableQuery(
        api.assistants.getById, 
        session?.assistant_id ? { id: session?.assistant_id as Id<"assistants"> } : "skip"
    );

    const {
        isLoading,
        renderMessages,
        renderChatInput
    } = useChat();

    const LoadingWrapper = useLoadingWrapper({ isLoading });

    // Determine if this is a multiple choice session
    const isMultipleChoice = assistant?.multiple_choice && assistant?.multiple_choice_questions && assistant.multiple_choice_questions.length > 0;

    if (isMultipleChoice) {
        return (
            <section className="min-h-screen bg-background pt-24 pb-24">
                <LoadingWrapper>
                    <div className="max-w-4xl mx-auto px-6">
                        <MultipleChoiceSession
                            sessionId={session?._id as Id<"sessions">}
                            questions={assistant.multiple_choice_questions || []}
                            greeting={assistant.greeting}
                            signOff={assistant.multiple_choice_sign_off}
                            assistantDisplayName={assistant.display_name || assistant.name}
                            isComplete={session?.isComplete}
                            existingAnswers={session?.multiple_choice_questions || []}
                            sessionMessages={session?.messages || []}
                        />
                    </div>
                </LoadingWrapper>
            </section>
        );
    }

    return (
        <section className="min-h-screen bg-background pt-24">
            <LoadingWrapper>
                <div className="max-w-4xl mx-auto px-6">
                    {renderMessages()}
                    {/* Spacer to prevent content from being hidden behind fixed footer */}
                    <div className={debug ? 'h-52' : 'h-40'} />
                    {renderChatInput()}
                </div>
            </LoadingWrapper>
        </section>
    )
}